'use strict';

import _ from 'lodash';

import './index.less';

import classnames from 'classnames';
import React from 'react';
import WithCoupon from '../../ui/newPayments/WithCoupon.jsx';
import subscriptionPlans from 'ck-core/source/collections/subscriptionPlans';
import { CURRENCY } from 'ck-core/source/data/Currency';
import trialCtaPlans from 'ck-website/source/data/trialCtaPlans';

import { planDurationLang } from 'ck-core/source/data/planLang';
import { PLAN_SIZE } from 'ck-core/source/data/PlanSize';

interface PlanCursor {}

interface Coupon {
	getMessage: (plan: PlanCursor, currency: CURRENCY) => string;
	name: () => string;
	percentOff(): () => number | undefined;
}

interface Props {
	planId: string;
	currency: CURRENCY;
	coupon?: Coupon;
	onClick: (coupon?: Coupon) => void;
	className: string;
	highlighted: boolean;
	background: string;
	colour?: string;
}

export class PaymentPlanRow extends React.Component<Props> {
	render() {
		const {
			highlighted,
			planId,
			currency,
			className,
			onClick,
			coupon,
			background,
			colour
		} = this.props;

		const isTrial = Object.keys(trialCtaPlans).includes(planId);

		let activeCoupon: Coupon | undefined;
		let durationLang;
		let fullPrice;
		let discount;
		let price;

		if (isTrial) {
			durationLang = 'Trial';
			price = CK.fn.formatPrice(this.props.currency, 0, {
				stylish: true,
				html: true,
				spaceCurrencySymbol: true
			});
		} else {
			const planCursor = subscriptionPlans(planId);
			const planType = {
				size: planCursor.family() ? PLAN_SIZE.FAMILY : PLAN_SIZE.INDIVIDUAL,
				product: planCursor.product(),
				duration: planCursor.durationKey()
			};

			activeCoupon = coupon && planCursor.isCouponApplicable(coupon, currency) ? coupon : undefined;

			const priceInCurrency = planCursor.priceInCurrency(currency, {
				coupon: activeCoupon,
				html: false,
				user: CK.user
			});

			if (priceInCurrency.discount > 0) {
				fullPrice = priceInCurrency.formattedFullPriceStylishly;
			}

			if (activeCoupon && activeCoupon.percentOff()) {
				discount = ' - ' + activeCoupon.percentOff() + '% off';
			}

			let formattedIntervalTitle = planCursor.formattedIntervalTitle();

			if (!formattedIntervalTitle || !_.isString(formattedIntervalTitle)) {
				CK.logger.warn('formattedIntervalTitle is nil', {
					planId: planId
				});
				formattedIntervalTitle = '';
			}

			durationLang = planDurationLang[planType.duration];
			price = priceInCurrency.formattedStylishly;
		}

		const classes = classnames(
			'PaymentPlanRow',
			'PaymentPlanLike',
			highlighted && 'PaymentPlanRow--selected',
			coupon && 'PaymentPlanRow--coupon',
			colour && 'PaymentPlanRow--colour-' + colour,
			className,
			isTrial && 'TrialPaymentPlanLike'
		);

		return (
			<div
				className={classes}
				onClick={() => onClick(activeCoupon)}
				id={`plan-${planId}`}
				style={
					!highlighted
						? {
								backgroundImage: `url(${background})`
						  }
						: {}
				}
			>
				<div className="PaymentPlanRow__header">
					<div className="PaymentPlanRow__name">
						{durationLang}
						{fullPrice ? (
							<div className="PaymentPlanRow__coupon-discount">
								{activeCoupon && activeCoupon.name()}
								{discount}
							</div>
						) : null}
					</div>
					<div className="PaymentPlanRow__price">
						<div
							// TODO: formattedStylishly should be in here, not in SubscriptionPlanSchema
							dangerouslySetInnerHTML={{ __html: price }}
						/>
						{fullPrice ? (
							<div
								className="PaymentPlanRow__coupon-fullPrice"
								dangerouslySetInnerHTML={{ __html: fullPrice }}
							/>
						) : null}
					</div>
				</div>
			</div>
		);
	}
}

export const ConnectedPaymentPlanRow = WithCoupon(PaymentPlanRow);
